import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createSectorsSettings as createSectorsSettingsRequest } from '@api/sectors';

import { ICreateSectorsSettingsDTO } from '@interfaces/map/dto/sectorsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ADD_SECTORS_SETTINGS, ALL_SECTORS, SECTOR_SETS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCreateSectorsSettings = (onSuccessCallback: () => void) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: createSectorsSettings,
		isLoading,
	} = useMutation<ICreateSectorsSettingsDTO>({
		mutationKey: [ADD_SECTORS_SETTINGS],
		mutationFn: createSectorsSettingsRequest,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.addSectorsSettings,
				type: ESnackbarTypes.success,
			}));

			onSuccessCallback();

			return [
				queryClient.invalidateQueries([SECTOR_SETS]),
				queryClient.invalidateQueries([ALL_SECTORS]),
			];
		},
	});

	return {
		createSectorsSettings,
		isCreatingSectorsSettings: isLoading,
	};
};
